import { Component } from '@angular/core';
    import { MatDialogRef } from '@angular/material';

// openDialogWithAResult
    @Component({
    selector: 'restricted-access',
        template: `<h4 md-dialog-title style="align-items: center">Restricted Access!</h4>
    <div md-dialog-content style="padding-bottom: 20px;">Only Admins are allowed to navigate into this section? </div>
    <div md-dialog-actions>
          <button mat-raised-button   (click)="dialogRef.close()">OK</button>
    </div>`,
        })
export class RestrictedAccessComponent {
constructor(public dialogRef: MatDialogRef<RestrictedAccessComponent>) {}
        }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/restrictedAccesss.component.ts